import React, { useState, useEffect } from "react";
import "./Home.css";

export default function Home() {
  const [countdown, setCountdown] = useState({ hours: 0, minutes: 0, seconds: 0 });
  const [lunchtimeStatus, setLunchtimeStatus] = useState('waiting');

  // Function to calculate lunchtime countdown
  const calculateLunchtimeCountdown = () => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentTime = currentHour * 60 + currentMinute;
    
    // Lunchtime is 11:30 AM (690 minutes) to 3:00 PM (900 minutes)
    const lunchStart = 690; // 11:30 AM
    const lunchEnd = 900;   // 3:00 PM
    
    if (currentTime >= lunchStart && currentTime < lunchEnd) {
      // Lunchtime is active - countdown to end
      const timeLeft = lunchEnd - currentTime;
      const hours = Math.floor(timeLeft / 60);
      const minutes = timeLeft % 60;
      const seconds = 0;
      
      setLunchtimeStatus('active');
      setCountdown({ hours, minutes, seconds });
    } else if (currentTime < lunchStart) {
      // Before lunchtime - countdown to start
      const timeLeft = lunchStart - currentTime;
      const hours = Math.floor(timeLeft / 60);
      const minutes = timeLeft % 60;
      const seconds = 0;
      
      setLunchtimeStatus('waiting');
      setCountdown({ hours, minutes, seconds });
    } else {
      // After lunchtime - countdown to tomorrow
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(11, 30, 0, 0);
      
      const timeLeft = tomorrow.getTime() - now.getTime();
      const hours = Math.floor(timeLeft / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
      
      setLunchtimeStatus('ended');
      setCountdown({ hours, minutes, seconds });
    }
  };

  // Update countdown every second
  useEffect(() => {
    calculateLunchtimeCountdown();
    const interval = setInterval(() => {
      calculateLunchtimeCountdown();
    }, 1000);
    
    return () => clearInterval(interval);
  }, []);
  return (
    <main>
      <section className="hero-overlay">
        <video autoPlay loop muted className="hero-video">
          <source src="/home_video.mp4" type="video/mp4" />
        </video>
        <div className="hero-content">
          <div className="hero-title-wrapper">
            <img
              src="/PH_Mascot_Fade.png"
              alt="Pizza House Mascot"
              className="hero-mascot"
            />
            <h1 className="hero-title">Welcome to The Pizza House</h1>
          </div>
          <p className="hero-subtitle">A Peterborough tradition since 1978</p>
          <button className="hero-button" onClick={() => {
            const menuSection = document.getElementById('menu');
            if (menuSection) menuSection.scrollIntoView({ behavior: 'smooth' });
          }}>View Menu</button>
          
          {/* Lunch Special Indicator */}
          {lunchtimeStatus === 'active' && (
            <button 
              className="lunch-special-button bg-green-700 text-white px-6 py-3 rounded-lg mt-4 text-center shadow-lg cursor-pointer transition-all duration-300 hover:bg-green-600 hover:scale-105"
              style={{ animation: 'fadeInUp 1s ease-out 2.6s forwards, pulse 2s ease-in-out 3.6s infinite' }}
              onClick={() => {
                const specialMenuSection = document.querySelector('#menu .lunch-special-section');
                if (specialMenuSection) specialMenuSection.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <div className="text-center mb-1">
                <svg className="w-6 h-6 mx-auto mb-1 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <div className="font-bold text-lg mb-1 font-['Segoe_UI']">
                Lunch Special is ON!
              </div>
              <div className="text-sm opacity-90 font-['Segoe_UI']">
                {countdown.hours > 0 && `${countdown.hours}hr `}
                {countdown.minutes}min {countdown.seconds}s left
              </div>
            </button>
          )}
          
          {lunchtimeStatus === 'waiting' && (
            <button 
              className="lunch-special-button bg-green-700 bg-opacity-80 text-white px-6 py-3 rounded-lg mt-4 text-center shadow-lg cursor-pointer transition-all duration-300 hover:bg-opacity-90 hover:scale-105"
              onClick={() => {
                const specialMenuSection = document.querySelector('#menu .lunch-special-section');
                if (specialMenuSection) specialMenuSection.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <div className="text-center mb-1">
                <svg className="w-6 h-6 mx-auto mb-1 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <div className="font-bold text-base mb-1 font-['Segoe_UI']">
                Lunch Special starts in
              </div>
              <div className="text-sm opacity-90 font-['Segoe_UI']">
                {countdown.hours > 0 && `${countdown.hours}hr `}
                {countdown.minutes}min {countdown.seconds}s
              </div>
            </button>
          )}
        </div>
        {/* Food Hygiene Badge - bottom right, no styling */}
        <img 
          src="/PizzaHouse-Food-Hygine.png" 
          alt="Food Hygiene Rating" 
          style={{ position: 'absolute', right: 0, bottom: 0, height: '4rem', width: 'auto' }}
        />
      </section>
    </main>
  );
}
